  import { Injectable } from '@angular/core';
import {protectedResources} from "../../auth-config";
import { HttpClient } from "@angular/common/http";
import {Observable, of, tap} from "rxjs";
import camelcaseKeys from "camelcase-keys";
import {
  BuildKitSettingTemplate,
} from "../../shared/models/build-kit.model";
  import {map} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class BuildKitSettingTemplateService {

  brennerSoftwareApiEndpoint: string = protectedResources.BrennerSoftwareApi.endpoint;

  constructor(
    private http: HttpClient
  ) {}

  get(): Observable<BuildKitSettingTemplate[]>{
    return this.http.get<any[]>(this.brennerSoftwareApiEndpoint + `buildKitSettingTemplate/getList/`);
  }

  create(newTemplate: BuildKitSettingTemplate): Observable<any> {
    return this.http.post<any>(this.brennerSoftwareApiEndpoint + 'buildKitSettingTemplate/create/',
      camelcaseKeys(newTemplate as any, {deep: true, pascalCase: true}));
  }

  update(newTemplate: BuildKitSettingTemplate): Observable<any> {
    return this.http.post<any>(this.brennerSoftwareApiEndpoint + 'buildKitSettingTemplate/modify/',
      camelcaseKeys(newTemplate as any, {deep: true, pascalCase: true}));
  }


  remove(buildKitSettingTemplateId: string): Observable<string>{
    return this.http.delete<any>(this.brennerSoftwareApiEndpoint + `buildKitSettingTemplate/delete/${buildKitSettingTemplateId}/`)
      .pipe(map(buildKitSettingTemplateDeleteResponse => buildKitSettingTemplateDeleteResponse.data?.id));
  }


}
